/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import GlobalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
} from '@tcp/core/src/utils/labels/globalAddEditAddress.labels';

export function AddressAutoCompleteDefault({ fillFormManually }) {
  const globalAddEditAddressLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_EDIT_ADDRESS_LABELS,
    GlobalAddEditAddressLabels
  );
  const addressFormLabels = {
    dontSeeYourAddress: renderLabel(
      globalAddEditAddressLabels.lbl_addEdit_dontSeeYourAddress,
      'lbl_addEdit_dontSeeYourAddress'
    ),
    enterAddressManually: renderLabel(
      globalAddEditAddressLabels.lbl_addEdit_enterAddressManually,
      'lbl_addEdit_enterAddressManually'
    ),
  };
  return (
    <>
      <BodyCopy component="div" className="elem-mr-XXXS dont-see-address">
        {addressFormLabels.dontSeeYourAddress}
      </BodyCopy>
      <Button
        buttonVariation="link-button"
        noLink
        dataLocator="enterAddressManually"
        aria-label={addressFormLabels.enterAddressManually}
        className="enter-manual-btn"
        onClick={fillFormManually}
      >
        <BodyCopy
          component="span"
          className="manual-addr-btn"
          fontWeight={['semibold']}
          color="blue.800"
        >
          {addressFormLabels.enterAddressManually}
        </BodyCopy>
      </Button>
    </>
  );
}

AddressAutoCompleteDefault.propTypes = {
  fillFormManually: PropTypes.func.isRequired,
  addressFormLabels: PropTypes.shape({}).isRequired,
};

export default AddressAutoCompleteDefault;
